<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path fill="#E1F5FE" d="M13.913 1.16v6.955h6.957v17.392h-8.116v-1.16H1.158V1.16h12.754z" transform="translate(-1132 -390) translate(127 318) translate(855 3) translate(150 69) translate(4 2.667)" />
                <path
                  fill="#13A2E8"
                  d="M14.381 13.733L12.499 11.85 14.064 10.283 14.385 10.604 15.815 9.181 17.378 10.75zM14.381 18.161L12.499 16.278 14.064 14.713 14.385 15.034 15.815 13.609 17.378 15.179zM5.536 13.287L9.965 13.287 9.965 11.073 5.536 11.073zM5.536 17.705L9.965 17.705 9.965 15.49 5.536 15.49zM14.384 22.592L12.499 20.709 14.064 19.141 14.382 19.46 15.812 18.028 17.38 19.594zM5.536 22.134L9.965 22.134 9.965 19.919 5.536 19.919z"
                  transform="translate(-1132 -390) translate(127 318) translate(855 3) translate(150 69) translate(4 2.667)"
                />
                <path fill="#164194" d="M0 0v26.562h22.133V6.18L15.955 0H0zm2.214 2.215h12.824l4.88 4.882v17.252H2.215V2.215z" transform="translate(-1132 -390) translate(127 318) translate(855 3) translate(150 69) translate(4 2.667)" />
                <path fill="#164194" d="M13.275 0v8.858h8.858V6.179L15.955 0h-2.68zm2.216 2.668l3.975 3.975h-3.975V2.668z" transform="translate(-1132 -390) translate(127 318) translate(855 3) translate(150 69) translate(4 2.667)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>